export  const EVENTS = {
    'successful_login':'successful login',
    'Login_page_loaded':'Login page loaded',
    'desktop_page_loaded':'User is on a desktop or laptop',
    'mobile_page_loaded':'User is on a mobile device',
    'event_create_edit':'Event created or edited sucessfully',
    'event_copy':'Event copy sucessfully',
    'meeting_create_sucessfully':'meeting created sucessfully',

}